import React, { createContext, useCallback, useEffect, useState } from "react";
import { getConfig } from './api/getConfig';
import { Preloader } from './components/Preloader';

export const AppContext = createContext({
  user: null,
  coaches: null,
  endpoints: null
});

export function AppContextProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState(null);

  const init = useCallback(async () => {
    try {
      setStatus('loading');
      setError(null);

      const { user, coaches, endpoints, wpnonce, json } = await getConfig();
      const coachesMap = new Map(Object.entries(coaches).map(([key, value]) => [+key, value]));

      setConfig({
        user,
        coaches: coachesMap,
        endpoints,
        json
      });
      setStatus('success');
      window.dataWP = {
        config: {
          endpoints,
          wpnonce
        }
      };
    } catch(e) {
      console.error(e);
      setError('Oops! Something went wrong');
      setStatus('error');
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  function reload() {
    init();
  }

  if(status === 'loading') {
    return <Preloader className="preloader" />
  }

  if(status === 'error') {
    return (
      <div className="error">
        <p className="error__msg">{error}</p>
        <button type="button" className="error__btn" onClick={reload}>Refresh</button>
      </div>
    );
  }

  const value = {
    ...config
  };

  if(status === 'success') {
    return (
      <AppContext.Provider value={value}>
        {children}
      </AppContext.Provider>
    );
  }
}
